import { invariant } from '@spotify/confidence-core-react';

// Extracts workflow type and instance id from a name like
// `workflows/<type>/instances/<instance-id>`.
export const parseWorkflowInstanceName = (
  name: string,
): { workflow: string; id: string } => {
  const parts = name.split('/');
  invariant(
    parts.length >= 4 && parts[0] === 'workflows' && parts[2] === 'instances',
    `Invalid workflow instance name format: ${name}`,
  );
  return { workflow: parts[1], id: parts[3] };
};
